import React from 'react';
import Grid from '@/components/global/Grid';
import Container from './Container';

/**
 * Grid Debug
 *
 * Helper Component for debugging grid layout
 * Toggle grid overly by pressing `ctrl + G`
 *
 * @returns ReactElement | null
 */
const GridDebug = () => {
    /**
     * Check we're not in production
     * If so return null
     */
    if (!(process.env.NODE_ENV === 'development')) {
        return null;
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [showGrid, setShowGrid] = React.useState(false);

    /**
     * Listen for ctrl + G to toggle grid
     * @param ev keyUp
     */
    const handleKey = (ev: KeyboardEvent) => {
        if ((ev as KeyboardEvent).key === 'g' && (ev as KeyboardEvent).ctrlKey) {
            setShowGrid((showGrid) => !showGrid);
        }
    };

    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(() => {
        window.addEventListener('keyup', handleKey);
        return () => {
            window.removeEventListener('keyup', handleKey);
        };
    }, []);

    return showGrid ? (
        <Container className="fixed top-0 left-0 right-0 bottom-0 pointer-events-none z-50">
            <Grid>
                {[...Array(12)].map((_, i) => (
                    <div key={i} style={{ background: '#bebeff2e', height: '100vh' }} />
                ))}
            </Grid>
        </Container>
    ) : null;
};

export default GridDebug;
